
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovataxtiserviceinpune() {



    const cardData =
    {
        keyword: 'Innova Taxi Service in Pune',
        heading: 'Meghana Cab : Innova Taxi Service in Pune',
        headingDescription: 'Meghana Cab offers Innova Taxi Service in Pune, providing a premium, spacious, and comfortable travel solution for every need—be it airport transfers, city commutes, corporate travel, sightseeing, or outstation trips. Our fleet of Innova taxis is meticulously maintained and equipped with air-conditioning, ample legroom, generous luggage space, and smooth interiors to ensure a luxurious ride.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is an iconic symbol of Pune’s Maratha legacy. Once a grand palace complex with seven stories and ornate halls, it was tragically gutted by a fire in 1828. Today, its massive gates, fortified walls, lotus-shaped fountains, and sprawling gardens continue to attract history lovers. Legends of palace intrigue and haunting folklore make it one of Pune’s most visited historical sites. The evening light-and-sound show offers a captivating audio-visual journey into Maratha history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "This majestic palace was built in 1892 by Sultan Aga Khan III and holds a revered place in India’s freedom struggle. It served as a place of incarceration for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace, surrounded by serene gardens, now functions as a memorial and museum, housing Gandhi’s belongings, rare photographs, and his ashes. It is a peaceful oasis that blends architecture, history, and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 35 km southwest of Pune, Sinhagad Fort is a hilltop military outpost famed for the 1670 Battle of Sinhagad, where Maratha warrior Tanaji Malusare displayed unparalleled bravery. Trekkers flock to this fort year-round for its rugged paths, panoramic views, and rustic food stalls serving local delicacies like 'pithla-bhakri'. The ruins of gates, watchtowers, and memorials transport visitors back to the era of valor and strategy. Monsoon is an especially magical time to visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Spread across 28 acres in Koregaon Park, the Osho Ashram is one of the world’s largest meditation centers. It blends Zen-inspired architecture with lush gardens and modern amenities. The resort offers dynamic meditations, healing therapies, creative workshops, and wellness programs. Visitors from over 100 countries come here for personal transformation, silence, and rejuvenation. It’s a unique sanctuary where mindfulness meets luxury, nestled within Pune’s urban heart."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "Dedicated to Lord Ganesha, this 130-year-old temple is a spiritual landmark in Pune’s Budhwar Peth area. The temple’s 7.5-foot-tall idol is adorned with over 40 kg of gold and is revered by politicians, celebrities, and millions of devotees. It becomes the epicenter of the city’s Ganesh Chaturthi celebrations, drawing lakhs of people. The temple is known for its vibrant atmosphere, intricate decorations, and a strong connection to Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, Pataleshwar is carved from a single basalt rock and features a sanctum with a Shiva lingam, a circular Nandi mandapa, and intricately carved pillars. Located on busy Jangli Maharaj Road, this monument offers a peaceful spiritual retreat amidst urban life. It stands as a testament to ancient Indian architecture and artistry and is a lesser-known gem in Pune’s heritage circuit."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing the everyday life of India’s past. From ornate doors and miniature paintings to musical instruments, sculptures, and antique utensils, the exhibits reflect the richness of Indian craftsmanship. The highlight is the reconstructed 'Mastani Mahal', representing the royal elegance of the Maratha court. Audio guides and themed galleries make this a must-visit cultural destination."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill offers a scenic trek with 103 stone steps leading to a hilltop complex of Peshwa-era temples. The Parvati Temple, dedicated to Goddess Parvati, offers panoramic views of Pune. A small museum here showcases artifacts from the Peshwa dynasty. The spot is perfect for early morning visits, photography, and spiritual reflection—especially during sunrise and winter months."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres on the southern outskirts of Pune, this well-maintained zoological park includes a snake park, zoo, and lake. It houses tigers, leopards, elephants, deer, crocodiles, and a wide variety of birds. It’s an educational hotspot for children and families, offering nature trails, animal adoption programs, and boating facilities. The zoo is a perfect mix of wildlife conservation and recreation."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Located in Wanowrie, Shinde Chhatri is a stunning 18th-century memorial dedicated to Maratha military leader Mahadji Shinde. The structure features elaborate Rajasthani-style domes, colorful stained-glass windows, and an atmosphere of serene grandeur. The adjoining Shiva temple and the samadhi (final resting place) of Shinde add to the historical depth. It’s one of Pune’s lesser-known heritage sites, rich in architecture and historical importance."
  }
],

"services": [
  {
    "name": "Innova Taxi Service Pune",
    "description": "Experience reliable and comfortable Innova taxi service in Pune, perfect for daily commutes, airport transfers, outstation trips, and special occasions. Our fleet features well-maintained vehicles with spacious interiors and professional chauffeurs ensuring a safe and pleasant journey."
  },
  {
    "name": "Affordable Innova Taxi Pune",
    "description": "Travel affordably without compromising on comfort with our budget-friendly Innova taxi services in Pune. We offer competitive rates, transparent pricing, and flexible packages tailored to meet your local or long-distance travel needs."
  },
  {
    "name": "Chauffeur Driven Innova Taxi Pune",
    "description": "Sit back and relax with our chauffeur-driven Innova taxis in Pune. Our skilled drivers are punctual, courteous, and knowledgeable about the city routes, providing you with a hassle-free travel experience whether for business or leisure."
  },
  {
    "name": "Online Booking Innova Taxi Pune",
    "description": "Book your Innova taxi online in Pune quickly and securely through our user-friendly platform. Enjoy instant confirmations, multiple payment options, and the convenience of scheduling pickups at your preferred time and location."
  },
  {
    "name": "Family Innova Taxi Pune",
    "description": "Travel comfortably with your family using our spacious Innova taxis in Pune. Designed to accommodate larger groups with ample legroom and luggage space, our vehicles ensure a safe and enjoyable journey for family outings, tours, and celebrations."
  },
  {
    "name": "Corporate Innova Taxi Pune",
    "description": "Elevate your corporate travel with our premium Innova taxi services in Pune. Ideal for business meetings, client pickups, airport transfers, and team travel, our taxis combine professionalism, comfort, and punctuality to meet all your corporate transport needs."
  },
  {
    "name": "Airport Transfer Innova Taxi Pune",
    "description": "Ensure timely and comfortable transfers to and from Pune airport with our Innova taxi services. Available 24/7, we provide reliable pickups and drop-offs with experienced chauffeurs and spacious vehicles suitable for travelers with luggage."
  },
  {
    "name": "Comfortable Innova Taxi Pune",
    "description": "Our Innova taxis in Pune are known for their superior comfort, featuring air conditioning, plush seating, and smooth rides. Whether for short trips within the city or long-distance travel, enjoy a relaxing journey every time."
  }
],
"tableData": [
  ["Innova Taxi Service Pune", "Affordable Innova Taxi Pune"],
  ["Chauffeur Driven Innova Taxi Pune", "Online Booking Innova Taxi Pune"],
  ["Family Innova Taxi Pune", "Corporate Innova Taxi Pune"],
  ["Airport Transfer Innova Taxi Pune", "Comfortable Innova Taxi Pune"]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Taxi Service in Pune",
        "WhyChoosedescription": "Our Innova taxi service in Pune offers a perfect blend of comfort, space, and performance—ideal for city rides, airport transfers, corporate trips, and outstation journeys. Travel with ease in a reliable, chauffeur-driven vehicle that’s built for comfort."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Ride for Groups and Families",
        "WhyChoosedescription": "With seating for 6–7 passengers, the Innova offers plush interiors, ample legroom, and superior ride quality—making it the best choice for family outings, group tours, and business delegations within Pune or to nearby destinations."
    },
    {
        "WhyChooseheading": "Experienced Drivers and Safe Travel",
        "WhyChoosedescription": "Our professional drivers are trained, background-verified, and familiar with city and highway routes. They ensure timely arrivals, safe driving practices, and a courteous service experience throughout your trip."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Every Innova taxi is thoroughly cleaned and sanitized before each trip. Regular maintenance checks ensure a smooth and safe ride every time, whether you're traveling short distances or planning an outstation journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for All Travel Needs",
        "WhyChoosedescription": "Choose from hourly rentals for local use, full-day packages, or outstation bookings based on your schedule. Customize your pickup/drop points and travel plan to fit your itinerary with ease."
    },
    {
        "WhyChooseheading": "All-Inclusive and Transparent Pricing",
        "WhyChoosedescription": "Our pricing includes driver allowances, tolls, fuel, and taxes—offering clear and upfront rates without hidden fees. You get premium service at affordable prices with complete billing transparency."
    },
    {
        "WhyChooseheading": "Perfect for Business Travel, Events, and Weekend Getaways",
        "WhyChoosedescription": "Whether you're heading to a corporate event, Pune Darshan, a wedding, or an outstation trip to places like Lonavala, Shirdi, or Mahabaleshwar, our Innova taxi service ensures reliable and comfortable travel."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Easy Reservations",
        "WhyChoosedescription": "Book your Innova taxi in Pune anytime via our website or customer care. Our 24/7 support ensures that your travel needs are handled quickly, whether it's a planned ride or last-minute request."
    }
]





























    }

const faqData = [
    {
        question: "How do I book an Innova taxi service in Pune?",
        answer: "You can book an Innova taxi by calling Meghana Cab at +91 9075462128 or using our website for fast and easy booking."
    },
    {
        question: "What types of travel can I use the Innova taxi for in Pune?",
        answer: "Our Innova taxi service is available for local travel, airport transfers, outstation trips, corporate travel, and sightseeing tours."
    },
    {
        question: "How many passengers can travel in the Innova taxi?",
        answer: "The Innova taxi comfortably seats 6 to 7 passengers along with luggage."
    },
    {
        question: "Is the Innova taxi service available 24/7 in Pune?",
        answer: "Yes, our Innova taxi service operates round the clock to accommodate your travel needs at any time."
    },
    {
        question: "Are the Innova taxis well-maintained and sanitized?",
        answer: "Absolutely. We ensure all taxis are regularly serviced, cleaned, and sanitized before every trip for your safety."
    },
    {
        question: "Can I book an Innova taxi for one-way or round trips?",
        answer: "Yes, both one-way and round-trip bookings are available based on your travel plans."
    },
    {
        question: "What is included in the taxi fare?",
        answer: "The fare covers driver charges, fuel, and tolls. Additional charges may apply for waiting time or parking."
    },
    {
        question: "Is it possible to book an Innova taxi on an hourly basis?",
        answer: "Yes, hourly rentals are offered for flexible usage within Pune or nearby areas."
    },
    {
        question: "Do you provide airport pickup and drop services with Innova taxis?",
        answer: "Yes, we offer prompt and comfortable airport transfer services using Innova taxis in Pune."
    },
    {
        question: "What payment options do you accept for Innova taxi bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Amit Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova taxi with Meghana Cab in Pune. The vehicle was clean, comfortable, and the driver was professional.”',
    },
    {
        name: 'Ms. Sneha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent Innova taxi service. Punctual and safe journey with friendly staff. Highly recommend Meghana Cab!”',
    },
];

















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const innovaTaxiServicePuneSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Taxi Service in Pune",
  "description": "Affordable and chauffeur-driven Innova taxi service in Pune. Ideal for family trips, corporate travel, airport transfers, with easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-taxi-service-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>Innova Taxi Service in Pune | Affordable Chauffeur Driven Taxi</title>
  <meta
    name="description"
    content="Book affordable and chauffeur-driven Innova taxi service in Pune for family trips, corporate travel, and airport transfers. Easy online booking available."
  />
  <meta
    name="keywords"
    content="Innova Taxi Service Pune, Affordable Innova Taxi Pune, Chauffeur Driven Innova Taxi Pune, Online Booking Innova Taxi Pune, Family Innova Taxi Pune, Corporate Innova Taxi Pune, Airport Transfer Innova Taxi Pune, Comfortable Innova Taxi Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaTaxiServicePuneSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovataxtiserviceinpune;